import { ApolloClient } from '@apollo/client'
import gql from 'graphql-tag'
import { UserInfo } from '../../../api'

export const QUERY = gql`
  query GetUserInfo($usernames: [String!]!) {
    getUserInfo(usernames: $usernames) {
      sub
      emailAddress
      firstName
      lastName
    }
  }
`

export const getUserInfo = async (
  client: ApolloClient<unknown>,
  usernames: string[],
): Promise<UserInfo[]> => {
  const userInfoQueryResult = await client.query<{
    getUserInfo: UserInfo[]
  }>({
    query: QUERY,
    variables: {
      usernames,
    },
  })

  return userInfoQueryResult.data.getUserInfo
}
